import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { EngagementService } from 'src/app/care/engagement/engagement.service';
import { Editor2Answer } from 'src/app/shared/models/misc.model';
import { TaskProcessContext } from 'src/app/task-process/shared/task-process-context.class';
import { SingleMessage } from '../../single-message-editor/single-message';
import { ChooseTemplateFlowService } from '../shared/choose-template-flow.service';
import { UploadService } from 'src/app/shared/services/upload.service';

@Component({
  selector: 'app-choose-write',
  templateUrl: './choose-write.component.html',
  styleUrls: ['./choose-write.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ChooseWriteComponent {
  @Input() taskProcessContext: TaskProcessContext;
  @Input() message: SingleMessage;

  editorInitialContent: Editor2Answer[];

  editorControl = new FormControl(null, Validators.required);

  constructor(
    public chooseTemplateFlowService: ChooseTemplateFlowService,
    public engagementService: EngagementService,
    private uploadService: UploadService
  ) {
    this.editorInitialContent = [
      {
        attachments: [],
        text: '',
        links: undefined, // convenience prop.
      },
    ];
    this.editorControl.valueChanges.subscribe(value => {
      if (!value || !value.length) {
        return;
      }
      const { attachments, text: content } = value[0];

      const { valid } = this.editorControl;
      chooseTemplateFlowService.isValid = valid;
      let attachment = undefined;
      if (attachments?.length) {
        const { pictureId: media_id } = attachments[0].value;
        const media_link = this.uploadService.pictureUrl(media_id);
        attachment = {
          image: {
            media_id,
            media_link,
          },
        };
      }
      chooseTemplateFlowService.messageData = { content, attachment };
    });
  }

  back() {
    this.engagementService.flowStep = null;
  }

  sendAnswer($event) {
    console.log($event);
  }
}
